// <핫이슈 박스 컴포넌트>
// 2021.11.01 기획서 기준  광고까지 총 5개 박스

// 1. Box Type1
// https://programs.sbs.co.kr/drama/onethewoman/clips/69893
// 클립 영상 타입 : 본방클립, 예고, 기획물
// 본방클립 해당 회차 여러 영상 중 마스터 클립 우선 노출, 마스터 클립이 없는 경우 서비스 예약일시 기준 최신클립 노출
// 예고|기획물 영상단위 노출
// 영상 길이 썸네일 좌 하단 노출
// 마우스 호버 시 미리보기 15초 : 기능부분은 해결하였으나  처음 플레이시 Dom 관련하여 해결해야하는 부분이 있음...
import React, { useEffect, useState } from 'react';
import VideoPlayer from '../../../pc/video/video-player';
import ShareBox from './ShareBox';
import Link from 'next/link';
import { toContentDate, toConvertPlayerTime } from '../../../../../src/common/utils/dateUtil';
import { getClickLinkParams } from '../../../../common/utils/appLinkUtil';

export default function Box (props) {
  const title = props.title; // 타이틀
  const contentDate = props.content_date; // 게시날짜(데이터 케스팅 유무 확인필요)
  const linkUrl = props.link_url; // 링크 url
  const mediaUrl = props.media_url; // 동영상 주소 url
  const imgUrl = props.img_url; // 이미지 주소 url
  const contentDateCast = contentDate ? toContentDate(contentDate) : '';
  const playtime = props.playtime;
  let thumbImg = imgUrl[0];
  if(thumbImg==null||thumbImg=='h'){
    thumbImg = imgUrl;
  }

  let convertPlaytime;
  if (playtime != null) {
    convertPlaytime = toConvertPlayerTime(playtime);
  } else {
    convertPlaytime = '00:00';
  }

  
  return (
    <div className='hotmodule_box_w_type1'>
      <Link href={getClickLinkParams(linkUrl,'div=hotissue')}>
        <a target={"_blank"} rel={"noopener noreferrer"} className='hmb_link'>
          <div className='hmb_video_w'>
            {/* 일반적으로 props 로 통으로 넘겨주지만 video 쪽은 양이 얼마 되지않아 변수 키로만 넘겨주고있음 */}
            <VideoPlayer className='hmb_video_clip' src={mediaUrl} poster={thumbImg} playtime={convertPlaytime} />
          </div>
          <div className='hmb_info_w'>
            {contentDate != null && contentDateCast !== null && contentDateCast !== '' && (
              <div className='hmbif_update_time_w'>
                <span className='icon_update_time'>
                  <svg xmlns='http://www.w3.org/2000/svg' width='15' height='15' viewBox='0 0 15.769 16'>
                    <g data-name='Icon feather-clock' transform='translate(0.5 0.5)'>
                      <path d='M17.769,10.5A7.443,7.443,0,0,1,10.385,18,7.443,7.443,0,0,1,3,10.5,7.443,7.443,0,0,1,10.385,3,7.443,7.443,0,0,1,17.769,10.5Z' transform='translate(-3 -3)' />
                      <path d='M18,9v6.231l4.154,2.077' transform='translate(-11.365 -6.769)' />
                    </g>
                  </svg>
                </span>
                <span className='text_update_time'>{contentDateCast}</span>
              </div>
            )}
            <strong className='hmbif_title'>{title}</strong>
          </div>

        </a>
      </Link>
      <ShareBox data={props} />
    </div>
  );
}// Finish default function Box()
